var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArsdFailedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zm5.835 20.445a1.002 1.002 0 0 1-.709 1.706.999.999 0 0 1-.709-.294l-4.42-4.44-4.441 4.42a.999.999 0 0 1-1.415-.004 1.002 1.002 0 0 1 .003-1.415l4.44-4.42-4.42-4.44a1.001 1.001 0 0 1 1.418-1.412l4.42 4.44 4.442-4.42a1.001 1.001 0 0 1 1.412 1.418l-4.441 4.42 4.42 4.441z",
    fill: "#FD3757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArsdFailedIcon);
export default __webpack_public_path__ + "static/media/arsdFailedIcon.03803e4c4f91c12e7d8c7483bc2c9bfc.svg";
export { ForwardRef as ReactComponent };